"use client";

import { Badge } from "@/components/ui/badge";
import type { InterviewStatus } from "@/lib/constants";
import { useDict } from "@/lib/i18n/context";

const tones: Record<
  InterviewStatus,
  "neutral" | "blue" | "green" | "red" | "amber"
> = {
  invited: "neutral",
  in_progress: "blue",
  completed: "green",
  violated: "red",
  expired: "amber",
};

export function StatusBadge({ status }: { status: InterviewStatus }) {
  const t = useDict();
  const tone = tones[status] ?? tones.invited;
  const label = t.status[status] ?? t.status.invited;
  return <Badge tone={tone}>{label}</Badge>;
}
